import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';

import useStyles from './styles';

const ClxConfirmDialog = React.memo(
    ({
        title,
        message,
        yesCallback,
        noCallback,
        yesButtonLabel = 'yes',
        noButtonLabel = 'no',
        open,
    }: {
        title?: string;
        message: string;
        yesCallback: () => void;
        noCallback?: () => void;
        yesButtonLabel?: string;
        noButtonLabel?: string;
        open: boolean;
    }) => {
        const classes = useStyles();

        return (
            <Dialog aria-labelledby="customized-dialog-title" open={open} fullWidth maxWidth="sm">
                {title && <MuiDialogTitle classes={{ root: classes.root }}>{title}</MuiDialogTitle>}
                <MuiDialogContent classes={{ root: classes.dialogContentRoot }} dividers>
                    <Typography gutterBottom>{message}</Typography>
                </MuiDialogContent>
                <MuiDialogActions classes={{ root: classes.dialogActionsRoot }}>
                    <Button autoFocus onClick={noCallback} variant="outlined">
                        {noButtonLabel}
                    </Button>
                    <Button autoFocus onClick={yesCallback} variant="contained" color="primary">
                        {yesButtonLabel}
                    </Button>
                </MuiDialogActions>
            </Dialog>
        );
    },
);
export default ClxConfirmDialog;
